<template>
    <v-card>
        <v-toolbar color="warning" dark>
            Foresters Live Well Plus in 3 Easy Steps
        </v-toolbar>
        <v-card-text>
            <div class="text-h2 pa-12">
                <ul class="mb-4">
                    <li>
                        <strong>Take the Training</strong>
                        <div>Complete the LMS course (Live Well Plus) to learn how to present Live Well Plus with confidence.</div>
                    </li>
                    <li>
                        <strong>Get Access to the E-App</strong>
                        <div>Create your account at <a href="https://ezbiz.foresters.com/" target="_blank">ezbiz.foresters.com</a> and confirm contracting/licensing before writing business.</div>
                    </li>
                    <li>
                        <strong>Access Product & Sales Tools</strong>
                        <div>Log in at <a href="https://ezbiz.foresters.com" target="_blank">ezbiz.foresters.com</a> to explore the product page, use the Sales Playbook, and start your first application.</div>
                    </li>
                </ul>
                <p class="pl-2">See more information on the Live Well Plus Homepage: <a href="/page/foresters-live-well-plus">https://hq.quility.com/page/foresters-live-well-plus</a></p>
            </div>
        </v-card-text>
        <v-card-actions class="justify-end">
            <v-btn depressed dark color="q_blue_1" @click="$emit('ok')">OK</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: "ForestersLiveWellPlusInstructions",
}
</script>

<style lang="scss" scoped>
ul {
    list-style: none;
    counter-reset: custom-counter;
    
    li::before {
        counter-increment: custom-counter;
        content: counter(custom-counter) ". ";
        font-weight: bold;
        margin-left: -16px;
    }
}
</style>